module.exports = __webpack_public_path__ + "img/boorger.34c8b91b.svg";